// What a link to the comparison can start it on (from the regulated and
// commercial bridging pages, public-stirlingpartners/regulated-bridging-finance.html
// and commercial-bridging-loans.html):
//   ?regulated=1           "Will you or a family member live there?" on Yes
//   ?commercial=1          property type on Commercial
//   &value=…&loan=…&term=…  the property value, loan (£) and term (months) typed on that page
//   &product=…             a product chosen there ("Apply"): its public reference, found in the results
// Anything missing or unreadable is left as the page would start anyway.

export interface LinkPreset {
  preset: Record<string, unknown>;
  applyRef: string | null;
}

const money = (v: string | null) => {
  const n = Number(String(v ?? '').replace(/[£,\s]/g, ''));
  return Number.isFinite(n) && n > 0 && n < 1e10 ? Math.round(n) : null;
};

export function linkPreset(search: string): LinkPreset {
  const q = new URLSearchParams(search);
  const preset: Record<string, unknown> = {};
  if (q.get('regulated') === '1') preset.liveIn = 'yes';
  if (q.get('commercial') === '1') preset.propertyType = 'commercial';
  const value = money(q.get('value'));
  const loan = money(q.get('loan'));
  if (value !== null) preset.value = value;
  if (loan !== null) preset.loan = loan;
  const term = Number(q.get('term'));
  if (Number.isInteger(term) && term > 0 && term <= 120) preset.term = term;
  const ref = q.get('product');
  return { preset, applyRef: ref && /^[A-Za-z0-9_-]{6,40}$/.test(ref) ? ref : null };
}
